<script lang="ts">
import { defineComponent } from 'vue'

import ViewBlogs from '~/vue/_organisms/views/ViewBlogs.vue'
import CardJob from '~/vue/_molecules/cards/CardJob.vue'

export default defineComponent({
    components: {
        'card--job': CardJob,
        'view--blogs': ViewBlogs
    }
})
</script>